export default "__VITE_ASSET__dlSjUe5J__"